import { Image } from '@react-pdf/renderer';
import { PDFCard } from './pdf-card';
import { BodyText } from './pdf-default-components';

export function PDFSymptomCard(props: {
  title: string;
  gaugeImage: string;
  scatterImage: string;
}) {
  const width = 150;
  const diagramWidth = (136.85 - 10 * 2) * 0.9;

  return (
    <PDFCard
      style={{
        width,
        alignItems: 'center'
      }}
    >
      <BodyText>{props.title}</BodyText>
      <Image
        src={props.gaugeImage}
        style={{
          width: diagramWidth
        }}
      />
      <Image src={props.scatterImage} />
    </PDFCard>
  );
}
